import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import AddSchool from "./pages/addSchool";
import ShowSchools from "./pages/showSchools";

import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <nav style={{ padding: 12, display: "flex", gap: 12 }}>
        <Link to="/addSchool">Add School</Link>
        <Link to="/showSchools">Show Schools</Link>
      </nav>
      <Routes>
        <Route path="/addSchool" element={<AddSchool />} />
        <Route path="/showSchools" element={<ShowSchools />} />
      </Routes>
    </BrowserRouter>
  );
}


